export default "__VITE_ASSET__dzuRPRcS__"